"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EscalationTemplatePlaceholders = exports.TemplatePlaceholders = exports.RulesetContent = exports.Outcome = void 0;
var Outcome;
(function (Outcome) {
    Outcome["PASS"] = "pass";
    Outcome["FAIL"] = "fail";
    Outcome["INDETERMINATE"] = "indeterminate";
})(Outcome || (exports.Outcome = Outcome = {}));
/** @deprecated */
var RulesetContent;
(function (RulesetContent) {
    RulesetContent["GEOFENCE"] = "GEOFENCE";
    RulesetContent["METRIC"] = "METRIC";
    RulesetContent["GEOFENCE_AND_METRIC"] = "GEOFENCE_AND_METRIC";
})(RulesetContent || (exports.RulesetContent = RulesetContent = {}));
var TemplatePlaceholders;
(function (TemplatePlaceholders) {
    TemplatePlaceholders["Customer"] = "[Customer]";
    TemplatePlaceholders["Ruleset"] = "[Ruleset]";
    TemplatePlaceholders["Timestamp"] = "[Timestamp]";
    TemplatePlaceholders["Device"] = "[Device]";
    TemplatePlaceholders["Type"] = "[Type]";
    TemplatePlaceholders["Name"] = "[Name]";
    TemplatePlaceholders["Group"] = "[Group]";
    TemplatePlaceholders["Rule"] = "[Rule]";
    TemplatePlaceholders["Attribute"] = "[Attribute]";
    TemplatePlaceholders["Value"] = "[Value]";
    TemplatePlaceholders["Value_Percent"] = "[Value Percent]";
    TemplatePlaceholders["Max"] = "[Max]";
    TemplatePlaceholders["Max_Percent"] = "[Max Percent]";
    TemplatePlaceholders["Min"] = "[Min]";
    TemplatePlaceholders["Min_Percent"] = "[Min Percent]";
    TemplatePlaceholders["Standard_Deviation"] = "[Standard Deviation]";
    TemplatePlaceholders["Period"] = "[Period]";
    TemplatePlaceholders["Unit"] = "[Unit]";
})(TemplatePlaceholders || (exports.TemplatePlaceholders = TemplatePlaceholders = {}));
var EscalationTemplatePlaceholders;
(function (EscalationTemplatePlaceholders) {
    EscalationTemplatePlaceholders["Notification_Person"] = "[Notification Person]";
    EscalationTemplatePlaceholders["Notification_Time"] = "[Notification Time]";
    EscalationTemplatePlaceholders["Escalation_Period"] = "[Escalation Period]";
    EscalationTemplatePlaceholders["Escalation_Person"] = "[Escalation Person]";
})(EscalationTemplatePlaceholders || (exports.EscalationTemplatePlaceholders = EscalationTemplatePlaceholders = {}));
